const d = {
    'app.login.log-in': 'Đăng Nhập',
    'app.login.login': 'Đăng Nhập',
    'app.login.remember-me': 'Ghi nhớ',
    'app.login.forgot-password':'Quên mật khẩu',
    'app.login.dontHaveAnAccount':'Bạn chưa có tài khoản',
    'app.login.signup':'Đăng ký'
}

export default d;